// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__2MWIJ","icon":"style_icon__1ZQMq","title":"style_title__21qBh","logo":"style_logo__B6kJX","bar":"style_bar__Mv1rx","logoContainer":"style_logoContainer__1U_vO"};